import React from 'react';

import { useScreenInfo } from 'src/hooks/common';
import { useOpenCloseState } from 'src/hooks/shared';

import { GlobalStateContext } from './GlobalStateContext';

export const GlobalStateProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isMobile } = useScreenInfo();

  const leftMenuDrawerState = useOpenCloseState(!isMobile);

  const contextValue = React.useMemo(
    () => ({
      leftMenuDrawerState,
    }),
    [leftMenuDrawerState],
  );

  return <GlobalStateContext value={contextValue}>{children}</GlobalStateContext>;
};
